import { Quill } from './index';

/**
 * Funcao auxilidar que recupera o conteudo
 * textual de QuillContents
 */
export function getQuillContentsText(contents) {
  if (!contents) return contents;

  if(typeof contents === 'string') {
    return contents.slice(1, contents.length-1);
  }

  const getContainer = () => {
    const container = document.createElement('div');
    container.remove();
    return container;
  };

  const quill = new Quill(getContainer());
  quill.setContents(JSON.parse(contents));
  const textContent = quill.getText();

  const formmatedTextContent = textContent.replace(/\r?\n|\r/g, ' ');
  return formmatedTextContent;
}
